<template>
  <a :href="path" download class="ot-btn"
    ><font-awesome-icon :icon="['fas', 'download']" class="mr-2" />
    {{ $t("downloadButton") }}</a
  >
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: "",
    },
  },
  computed: {
    path() {
      return window.data_vis_uri + this.href;
    },
  },
};
</script>
